module.exports = __webpack_public_path__ + "static/media/dataNotFound.a258fa03.svg";